module.exports = __webpack_public_path__ + "img/34_3.2d16b30b.png";